export default __webpack_public_path__ + "static/screenshot-timeseries-chart--mobile-ad1e9caa1113d24dcf6549d8e8f6dac4.png";